import { Component, computed, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { SharedBillingInvitationService } from './core/shared-billing-invitation.service';
import { RouterOutlet } from '@angular/router';
import { AuthenticationService } from './authentication/authentication.service';
import { MatCardModule } from '@angular/material/card';
import { MatProgressBarModule } from '@angular/material/progress-bar';

@Component({
  selector: 'app-root',
  standalone: true,   
  imports: [RouterOutlet, MatCardModule, MatProgressBarModule, MatButtonModule],
  templateUrl: './app.component.html'
})
export class AppComponent  {

  private authenticationService = inject(AuthenticationService);

  protected readonly invitations = inject(SharedBillingInvitationService);

  constructor() {
    this.invitations.start();
  }

  viewState = computed(() => {
    return {
      showAuthenticating: this.authenticationService.currentUserState() === undefined,
      showRoutes: this.authenticationService.currentUserState() !== undefined,
    }
  });

}
